export default __webpack_public_path__ + "static/warning-messages-body-dont-d0135fd1a45ced0eb1587229d90604f9.png";